import classNames from "classnames"
import React, { ReactNode } from "react"

export type SectionProps = {
  children: ReactNode
  width: "small" | "medium" | "large" | "full"
  horizontalPadding: boolean
  gap?: boolean
}

export const Section = ({
  children,
  width,
  horizontalPadding = true,
  gap = false,
}) => {
  const className = classNames({
    "w-full flex flex-col items-center": true,
    "gap-6 lg:gap-12": Boolean(gap),
    "px-5 lg:px-14": horizontalPadding === true,
    "max-w-4xl": width === "medium", // 56rem - horizontal padding
    "max-w-8xl": width === "large", // 80rem - horizontal padding
  })

  return <section className={className}>{children}</section>
}
